import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { fetchDealActivityThunk } from './activity';
import { isErrorWithMessage } from '../../helper';
import ReminderApi from '../../apis/reminder';
import { resettingReminderLoader } from '../slices/reminder';
import { RootState } from '../store';
import { AddDealReminderParams, DeleteDealReminderParams } from '../../params/pipeline';

export const getDealsRemindersThunk = createAsyncThunk(
    'reminder/fetch',
    async (id: number, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ReminderApi.getDealsReminders(state.app.token, id);
            if (response?.success === 1) {
                return response.reminders;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReminderLoader());
        }
    }
);

export const addDealReminderThunk = createAsyncThunk(
    'reminder/create',
    async (data: AddDealReminderParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ReminderApi.addDealReminder(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(getDealsRemindersThunk(data.deal_id)).unwrap();
                await dispatch(fetchDealActivityThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReminderLoader());
        }
    }
);

export const editDealReminderThunk = createAsyncThunk(
    'reminder/edit',
    async (data: AddDealReminderParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ReminderApi.editDealReminder(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(getDealsRemindersThunk(data.deal_id)).unwrap();
                await dispatch(fetchDealActivityThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReminderLoader());
        }
    }
);

export const deleteDealReminderThunk = createAsyncThunk(
    'reminder/delete',
    async (data: DeleteDealReminderParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ReminderApi.deleteDealReminder(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(getDealsRemindersThunk(data.deal_id)).unwrap();
                await dispatch(fetchDealActivityThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingReminderLoader());
        }
    }
);